import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/crateForecast'

const crateForecast = axios.create({
  baseURL
})

interceptorsSetup(crateForecast)

export default class Forecast {
  static async get (forecastQuery) {
    const result = await crateForecast.get('/forecast/' + forecastQuery.siteId, {
      params:
      {
        start: forecastQuery.start,
        end: forecastQuery.end,
        collectMean: forecastQuery.collectMean,
        washingMean: forecastQuery.washingMean,
        repairMean: forecastQuery.repairMean,
        rejectMean: forecastQuery.rejectMean,
        deliveryMean: forecastQuery.deliveryMean,
        ...(forecastQuery.siteId === 'FRA0' && { weeklyMeanSimorep: forecastQuery.weeklyMeanSimorep })
      }
    })
    return result.data
  }

  static async getComments (commentQuery) {
    const result = await crateForecast.get('/comment/' + commentQuery.siteId, {
      params:
      {
        start: commentQuery.start,
        end: commentQuery.end
      }
    })
    return result.data
  }

  static async getHolidays (commentQuery) {
    const result = await crateForecast.get('/holidays/' + commentQuery.siteId)
    return result.data
  }

  static async createFakeShipments (shipment) {
    const result = await crateForecast.post('/fakeshipments', shipment)
    return result.data
  }

  static async createHoliday (holiday) {
    const result = await crateForecast.post('/holidays', holiday)
    return result.data
  }

  static async removeHoliday (holiday) {
    const result = await crateForecast.post('/remove/holidays', holiday)
    return result.data
  }

  static async createComment (comment) {
    const result = await crateForecast.post('/comment', comment)
    return result.data
  }

  static async updateComment (comment) {
    const result = await crateForecast.post('/comment/edit', comment)
    return result.data
  }

  static async deleteComment (comment) {
    const result = await crateForecast.post('/comment/delete', comment)
    return result.data
  }

  static async getSimulation (simulationQuery) {
    const result = await crateForecast.get('/simulation', {
      params: simulationQuery
    })
    return result.data
  }

  static async create (newForecast) {
    const result = await crateForecast.post('/', newForecast)
    return result.data
  }

  static async createSimulation (simulations) {
    const result = await crateForecast.post('/simulation', simulations)
    return result.data
  }

  static async resetSimulations (simulation) {
    const result = await crateForecast.post('/reset', simulation)
    return result.data
  }

  static async archiveSimulations (ids) {
    const result = await crateForecast.put('/simulations/archive', { ids })
    return result.data
  }

  static async archiveFakeShipments (ids) {
    const result = await crateForecast.put('/fakeshipments/archive', { ids })
    return result.data
  }

  static async getMovedShipments (query) {
    const result = await crateForecast.get('/movedshipments/' + query.siteId, {
      params:
      {
        start: query.start,
        end: query.end
      }
    })
    return result.data
  }

  static async createMovedShipments (shipments) {
    const result = await crateForecast.post('/movedshipments', { shipments })
    return result.data
  }

  static async editMovedShipment (shipment) {
    const result = await crateForecast.post('/movedshipments/edit', shipment)
    return result.data
  }

  static async archiveMovedShipments (ids) {
    const result = await crateForecast.put('/movedshipments/archive', { ids })
    return result.data
  }

  static async update (forecast) {
    const result = await crateForecast.post('/update', forecast)
    return result.data
  }

  static async archive (forecast) {
    const result = await crateForecast.put('/archive/' + forecast)
    return result.data
  }
}
